import styled from "styled-components";
import colors from "assets/styles/colors";

export default styled.div`
    min-width: 500px;
    max-width: 600px;
    padding: 16px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 2000;

    .chart-header {
        margin-bottom: 16px;

        h4 {
            margin: 0 0 4px 0;
            font-size: 16px;
            font-weight: 600;
            color: ${colors.textBlack};
        }

        .chart-subtitle {
            font-size: 12px;
            color: ${colors.textGrey};
        }
    }

    .chart-body {
        height: 250px;
        position: relative;

        .loading,
        .error {
            position: absolute;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: ${colors.textGrey};
        }

        .error {
            color: ${colors.accentRed};
        }

        .chart-container {
            height: 100%;
            position: relative;
        }
    }
`;
